var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("notifications", {
        attrs: { group: "foo", classes: "paypoint-notification-style" },
      }),
      _vm._v(" "),
      _c(
        "b-overlay",
        {
          attrs: { show: _vm.formBusy, rounded: "sm", "spinner-small": false },
        },
        [
          _c("div", { attrs: { id: "content-container-with-border" } }, [
            !this.UIModeForgotPassword
              ? _c("div", [
                  _c(
                    "form",
                    {
                      attrs: { id: "submitLoginForm" },
                      on: { submit: _vm.submitLoginForm },
                    },
                    [
                      _c("h3", [_vm._v("Welcome")]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { staticClass: "form-label" }, [
                                _vm._v("Site Number/Email\n                  "),
                                _c(
                                  "span",
                                  { attrs: { id: "coloured-subnote" } },
                                  [_vm._v("*")]
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "badged-inputbox" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.loginData.siteid_email,
                                        expression: "loginData.siteid_email",
                                      },
                                    ],
                                    ref: "siteid_emailFformField",
                                    staticClass: "form-control form-control-lg",
                                    attrs: {
                                      id: "siteid_email",
                                      name: "siteid_email",
                                      type: "text",
                                      autocomplete: "off",
                                    },
                                    domProps: {
                                      value: _vm.loginData.siteid_email,
                                    },
                                    on: {
                                      keyup: function ($event) {
                                        return _vm.onUsernameChange(
                                          _vm.loginData.siteid_email
                                        )
                                      },
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.loginData,
                                          "siteid_email",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "transition",
                                    { attrs: { name: "bounce" } },
                                    [
                                      _vm.badgeString && _vm.badgeString !== ""
                                        ? _c(
                                            "Badge",
                                            {
                                              staticClass: "overlayed-badge",
                                              attrs: {
                                                variant: "retailer-type-yellow",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.badgeString) + " "
                                              ),
                                              _vm.accountLookupInAction
                                                ? _c("b-spinner", {
                                                    attrs: {
                                                      type: "grow",
                                                      variant: "secondary",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "transition-group",
                                { attrs: { tag: "div", name: "slide-fade" } },
                                [
                                  _vm.displayAccountChoice
                                    ? _c(
                                        "div",
                                        {
                                          key: "container",
                                          staticClass: "form-group",
                                        },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "form-label" },
                                            [_vm._v(" ")]
                                          ),
                                          _vm._v(" "),
                                          _c("DeviceChoice", {
                                            attrs: {
                                              displayAccountChoice:
                                                _vm.displayAccountChoice,
                                              clickHandler:
                                                _vm.clickHandlerCard,
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "transition-group",
                        { attrs: { tag: "div", name: "slide-fade" } },
                        [
                          _vm.loginData.Username != null &&
                          !_vm.displayAccountChoice
                            ? _c(
                                "div",
                                { key: "container", staticClass: "form-group" },
                                [
                                  _c(
                                    "label",
                                    { key: "label", staticClass: "form-label" },
                                    [_vm._v("Username")]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.loginData.Username,
                                        expression: "loginData.Username",
                                      },
                                    ],
                                    key: "Username",
                                    staticClass: "form-control form-control-lg",
                                    attrs: {
                                      id: "username",
                                      name: "username",
                                      type: "text",
                                      autocomplete: "off",
                                    },
                                    domProps: { value: _vm.loginData.Username },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.loginData,
                                          "Username",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "transition-group",
                        { attrs: { tag: "div", name: "slide-fade" } },
                        [
                          !_vm.displayAccountChoice
                            ? _c(
                                "div",
                                { key: "container", staticClass: "form-group" },
                                [
                                  _c("label", { staticClass: "form-label" }, [
                                    _vm._v("Password"),
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.loginData.Password,
                                        expression: "loginData.Password",
                                      },
                                    ],
                                    key: "Password",
                                    staticClass: "form-control form-control-lg",
                                    attrs: {
                                      id: "password",
                                      name: "password",
                                      type: "password",
                                      autocomplete: "off",
                                    },
                                    domProps: { value: _vm.loginData.Password },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.loginData,
                                          "Password",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      this.loginType == "agent"
                        ? _c("div", { staticClass: "paypoint-link" }, [
                            _c(
                              "a",
                              {
                                attrs: { id: "agent-forgot-password-cta" },
                                on: {
                                  click: function ($event) {
                                    return _vm.forgotPasswordClickHandler()
                                  },
                                },
                              },
                              [_c("em", [_vm._v("Forgot password?")])]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.displayAccountChoice
                        ? _c("div", { staticClass: "bottom-section" }, [
                            _c("div", {
                              staticClass: "form-group form-group-errors",
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "login-button" },
                              [
                                _c(
                                  "ButtonNew",
                                  {
                                    attrs: {
                                      buttonId: "loginButton",
                                      variant: "search",
                                      type: "submit",
                                      isBusy: false,
                                      isDisabled: _vm.isLoginButtonDisabled(),
                                      datacy: "submit-login-form-button",
                                      onClick: _vm.resetNotifications,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "icon",
                                          fn: function () {
                                            return [
                                              _c("RightArrowIcon", {
                                                attrs: {
                                                  internalColour:
                                                    _vm.isLoginButtonDisabled()
                                                      ? "#BEBEBE"
                                                      : "#FFFFFF",
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      2288079342
                                    ),
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.loginButtonString) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.displayAccountChoice
                        ? _c("div", { attrs: { id: "blurb" } }, [
                            _c("span", { attrs: { id: "coloured-subnote" } }, [
                              _vm._v("*"),
                            ]),
                            _c("em", [
                              _vm._v(
                                "Email Log in - only applicable for Agents accessing statement\n              documents."
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { attrs: { id: "click-to-register" } }, [
                              _vm._v(
                                "\n              If you have been sent a registration letter,\n              "
                              ),
                              _c(
                                "a",
                                { attrs: { href: "/Account/Register" } },
                                [
                                  _vm._v(
                                    "click here to register to access this site."
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("p", [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.enablePayPointLiteLoginJourney()
                                      },
                                    },
                                  },
                                  [_vm._v(" ")]
                                ),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ])
              : this.forceUserToChangePassword
              ? _c(
                  "div",
                  [
                    _c("PPConnectForcePasswordReset", {
                      attrs: {
                        isDisabledCallback:
                          _vm.isForgotPasswordbuttonDisabledPPMini,
                        submitPasswordForgotFormCallback:
                          _vm.submitPasswordForgotForm,
                        email: this.loginData.siteid_email,
                        isBusy: _vm.forgotPasswordFormBusy,
                        backToLoginPageClickHandler:
                          _vm.backToLoginPageClickHandler,
                      },
                    }),
                  ],
                  1
                )
              : _c(
                  "div",
                  [
                    _c("ForgotPasswordContent", {
                      attrs: {
                        isDisabledCallback: _vm.isForgotPasswordbuttonDisabled,
                        submitPasswordForgotFormCallback:
                          _vm.submitPasswordForgotForm,
                        email: this.loginData.siteid_email,
                        isBusy: _vm.forgotPasswordFormBusy,
                        backToLoginPageClickHandler:
                          _vm.backToLoginPageClickHandler,
                      },
                    }),
                  ],
                  1
                ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }